import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    left: 0 !important;\n    .", "menu-item {\n      height: 35px;\n      line-height: 35px;\n    }\n    .", "menu-item-inner {\n      height: 35px;\n      padding-left: ", ";\n      overflow: visible;\n      .next-menu-item-text {\n        margin-left: ", ";\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Menu } from '@alicloud/console-components';
var SMenu = styled(MenuFilterProps)(_templateObject(), getPrefix, getPrefix, function (_ref) {
  var selectedKeys = _ref.selectedKeys;
  return selectedKeys.length ? '8px' : 0;
}, function (_ref2) {
  var selectedKeys = _ref2.selectedKeys;
  return selectedKeys.length ? '8px' : 0;
});

function MenuFilterProps(_ref3) {
  var fusionPrefix = _ref3.fusionPrefix,
      selectedKeys = _ref3.selectedKeys,
      props = _objectWithoutProperties(_ref3, ["fusionPrefix", "selectedKeys"]);

  return /*#__PURE__*/React.createElement(Menu, _extends({}, props, {
    selectedKeys: selectedKeys
  }));
}

function getPrefix(_ref4) {
  var fusionPrefix = _ref4.fusionPrefix;
  return fusionPrefix;
}

export default SMenu;